<template>
  <div class="login-root">
    <!-- Panel izquierdo: imagen + branding -->
    <div class="login-side">
      <div class="login-side__glow"></div>
      <div class="login-side__ring"></div>
      <div class="login-side__content">
        <div class="login-brand">
          <img src="/logo.ico" alt="CucuruchoOnline" class="login-brand__logo" />
          <span class="login-brand__name">CucuruchoOnline</span>
        </div>
        <div class="login-side__img-wrap">
          <img src="../assets/cucurucho-sf.png" alt="Cucurucho" class="login-side__img" />
        </div>
        <p class="login-side__tagline">Gestión digital de tu hermandad</p>
      </div>
    </div>

    <!-- Panel derecho: formulario -->
    <div class="login-form-panel">
      <div class="login-card">
        <div class="login-card__header">
          <h1 class="login-card__title">Iniciar Sesión</h1>
          <p class="login-card__subtitle">Accedé al sistema con tus credenciales</p>
        </div>

        <form @submit.prevent="login" class="login-form">
          <!-- Usuario -->
          <div class="field-group">
            <label class="field-label">Usuario</label>
            <div class="field-input-wrap" :class="{ 'field-input-wrap--disabled': loading }">
              <span class="field-icon">👤</span>
              <input
                v-model="usuario"
                type="text"
                class="field-input"
                placeholder="Ingresá tu usuario"
                required
                :disabled="loading"
              />
            </div>
          </div>

          <!-- Password -->
          <div class="field-group">
            <label class="field-label">Contraseña</label>
            <div class="field-input-wrap" :class="{ 'field-input-wrap--disabled': loading }">
              <span class="field-icon">🔒</span>
              <input
                v-model="password"
                type="password"
                class="field-input"
                placeholder="Ingresá tu contraseña"
                required
                :disabled="loading"
              />
            </div>
          </div>

          <!-- Error -->
          <transition name="fade">
            <div v-if="error" class="login-error">
              ⚠️ {{ error_msg }}
            </div>
          </transition>

          <!-- Botón submit -->
          <button type="submit" class="login-btn" :disabled="loading">
            <span v-if="!loading">Iniciar Sesión →</span>
            <span v-else class="login-btn__spinner"></span>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { EncryptionService } from "../utils/encryption";

export default {
  name: "LoginView",
  components: {},
  data: function () {
    return {
      usuario: "",
      password: "",
      error: false,
      error_msg: "",
      loading: false,
    };
  },
  async mounted() {
    await EncryptionService.init();
  },
  methods: {
    async getProfile() {
      const apiUrl = `https://adcl0t3ai4.execute-api.us-east-1.amazonaws.com/dev/api/profile?user=${this.$cookies.get("user")}`;
      const token = this.$cookies.get("token");
      const config = { headers: { Authorization: `Bearer ${token}` } };

      axios
        .get(apiUrl, config)
        .then((response) => {
          const records = response.data.records;
          if (!Array.isArray(records) || records.length === 0) return;
          const perfil = records[0];
          const { nombre_hermandad, logo, cuiReq, templateRecibo, montoCustom, correo } = perfil;
          this.$cookies.set("hermandad", nombre_hermandad, "1d", "", "", true, "Strict");
          this.$cookies.set("logo", logo, "1d", "", "", true, "Strict");
          this.$cookies.set("cuiReq", cuiReq, "1d", "", "", true, "Strict");
          this.$cookies.set("templateRecibo", templateRecibo, "1d", "", "", true, "Strict");
          this.$cookies.set("montoCustom", montoCustom, "1d", "", "", true, "Strict");
          this.$cookies.set("correoH", correo, "1d", "", "", true, "Strict");
        })
        .catch(() => {
          this.showSessionExpiredDialog = true;
        });
    },
    async login() {
      this.loading = true;
      const loginUrl = "https://wm1xvvtarj.execute-api.us-east-1.amazonaws.com/dev/login";
      const encryptedPassword = await EncryptionService.encrypt(this.password);
      const encryptedUsername = await EncryptionService.encrypt(this.usuario);

      if (!encryptedPassword || !encryptedUsername) {
        this.error = true;
        this.error_msg = "Error al cifrar credenciales. Intente nuevamente.";
        this.loading = false;
        return;
      }

      const loginData = { username: encryptedUsername, password: encryptedPassword };

      axios
        .post(loginUrl, loginData)
        .then((response) => {
          if (response.data.status === "Ok") {
            this.error = false;
            this.error_msg = "";
            this.loading = false;
            const token = response.data.jwtToken;
            this.$cookies.set("user", this.usuario, "1d", "", "", true, "Strict");
            this.$cookies.set("token", token, { expires: "1d", secure: true, httpOnly: true, sameSite: "Strict" });
            this.$nextTick(() => {
              if (this.$cookies.get("token") && this.$cookies.get("user")) {
                if (this.$cookies.get("user")) {
                  this.getProfile();
                  this.$router.push("dashboard");
                }
              }
            });
          } else {
            this.error = true;
            this.error_msg = response.data.error_msg;
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

* { box-sizing: border-box; margin: 0; padding: 0; }

.login-root {
  font-family: 'Inter', sans-serif;
  display: flex;
  min-height: 100vh;
  background: var(--sys-bg);
}

/* ── PANEL IZQUIERDO ── */
.login-side {
  flex: 0 0 44%;
  background: linear-gradient(160deg, #0a0a12 0%, #1a0a30 60%, #0d1117 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.login-side__glow {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: 400px; height: 400px;
  background: radial-gradient(circle, rgba(123,47,247,0.22) 0%, transparent 70%);
  border-radius: 50%;
  pointer-events: none;
}

.login-side__ring {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: 460px; height: 460px;
  border-radius: 50%;
  border: 1px solid rgba(123,47,247,0.18);
  pointer-events: none;
  animation: ring-pulse 4s ease-in-out infinite;
}
@keyframes ring-pulse {
  0%, 100% { opacity: 0.4; transform: translate(-50%, -50%) scale(1); }
  50%       { opacity: 1;   transform: translate(-50%, -50%) scale(1.04); }
}

.login-side__content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 40px;
}

.login-brand {
  display: flex;
  align-items: center;
  gap: 12px;
}
.login-brand__logo {
  height: 40px;
  width: auto;
  border-radius: 8px;
}
.login-brand__name {
  font-size: 1.25rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.02em;
}

.login-side__img-wrap {
  width: 260px;
  height: 380px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-side__img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: drop-shadow(0 20px 50px rgba(0,0,0,0.7));
  animation: float-img 6s ease-in-out infinite;
}
@keyframes float-img {
  0%, 100% { transform: translateY(0); }
  50%       { transform: translateY(-10px); }
}

.login-side__tagline {
  color: rgba(255,255,255,0.45);
  font-size: 0.88rem;
  font-weight: 400;
  letter-spacing: 0.03em;
  text-align: center;
}

/* ── PANEL DERECHO ── */
.login-form-panel {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  background: var(--sys-bg);
}

.login-card {
  width: 100%;
  max-width: 420px;
  background: var(--sys-card-bg);
  border: 1px solid var(--sys-card-border);
  border-radius: 20px;
  padding: 44px 40px;
  backdrop-filter: blur(16px);
  box-shadow: 0 20px 60px rgba(0,0,0,0.5);
  animation: card-in 0.5s ease both;
}
@keyframes card-in {
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
}

.login-card__header {
  margin-bottom: 36px;
}
.login-card__title {
  font-size: 1.9rem;
  font-weight: 800;
  color: var(--sys-text-primary);
  margin-bottom: 8px;
}
.login-card__subtitle {
  font-size: 0.92rem;
  color: var(--sys-text-secondary);
}

/* ── FORMULARIO ── */
.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.field-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-label {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--sys-text-secondary);
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.field-input-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--sys-input-bg);
  border: 1px solid var(--sys-card-border);
  border-radius: 10px;
  padding: 12px 16px;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.field-input-wrap:focus-within {
  border-color: rgba(123,47,247,0.7);
  box-shadow: 0 0 0 3px rgba(123,47,247,0.12);
}
.field-input-wrap--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.field-icon {
  font-size: 1rem;
  flex-shrink: 0;
}

.field-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: var(--sys-text-primary);
  font-family: 'Inter', sans-serif;
  font-size: 0.95rem;
}
.field-input::placeholder {
  color: var(--sys-text-secondary);
}

/* ── ERROR ── */
.login-error {
  background: rgba(239, 68, 68, 0.12);
  border: 1px solid rgba(239,68,68,0.3);
  border-radius: 10px;
  padding: 12px 16px;
  font-size: 0.88rem;
  color: #fca5a5;
}

/* ── BOTÓN ── */
.login-btn {
  width: 100%;
  padding: 15px;
  background: linear-gradient(135deg, #7b2ff7, #4a1b9a);
  border: none;
  border-radius: 12px;
  color: #fff;
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.25s;
  box-shadow: 0 6px 20px rgba(123,47,247,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 52px;
  margin-top: 8px;
}
.login-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(123,47,247,0.55);
}
.login-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.login-btn__spinner {
  width: 22px; height: 22px;
  border: 3px solid rgba(255,255,255,0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ── FADE TRANSITION ── */
.fade-enter-active, .fade-leave-active { transition: opacity 0.3s; }
.fade-enter, .fade-leave-to { opacity: 0; }

/* ── RESPONSIVE ── */
@media (max-width: 768px) {
  .login-root { flex-direction: column; }
  .login-side {
    flex: 0 0 auto;
    padding: 40px 20px;
    min-height: 300px;
  }
  .login-side__img-wrap { width: 160px; height: 220px; }
  .login-form-panel { padding: 24px 16px; }
  .login-card { padding: 32px 24px; }
}
</style>
